/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useFormState, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import InputMask from "../../InputMask";
import { generateFormFieldRules } from "../services/form.service";

function FormPhoneField(props) {
  const { fieldProps, control, formProps, disabled } = props;
  const { errors } = useFormState({ control, name: fieldProps.key });

  const defaultValue =
    formProps[fieldProps.key] || fieldProps.defaultValue || "";

  const handleOnBlur = (e, field) => {
    const digitsOnly = field.value?.replace(/[^0-9]/g, "") || "";
    if (digitsOnly.length === 0) {
      field.onChange("");
      // eslint-disable-next-line no-param-reassign
      e.target.value = ""; // Clear the visual input, eg. "("
    }
  };

  const rules = generateFormFieldRules(fieldProps);
  return (
    <FormControl fullWidth margin="dense" sx={{ minHeight: "4.6875rem" }}>
      <Controller
        name={fieldProps.key}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onBlur, ...field } }) => (
          <TextField
            {...field}
            name={fieldProps.key}
            label={fieldProps.label}
            id={fieldProps.key}
            aria-describedby={
              errors[fieldProps.key] ? `${fieldProps.key}-error` : undefined
            }
            disabled={disabled}
            required={fieldProps.validate?.required}
            error={!!errors[fieldProps.key]}
            variant="standard"
            autoComplete={fieldProps.key}
            slotProps={{
              input: {
                inputComponent: InputMask,
                inputProps: {
                  mask: "(000)000-0000",
                  placeholderChar: "_",
                  isLazy: field.value?.replace(/[^0-9]/g, "").length === 0,
                  overwrite: true,
                },
              },
            }}
            onBlur={(e) => {
              handleOnBlur(e, field);
              onBlur(e);
            }}
          />
        )}
        rules={rules}
      />
      {errors[fieldProps.key] && (
        <FormHelperText error id={`${fieldProps.key}-error`} sx={{ margin: 0 }}>
          {errors[fieldProps.key].type === "required"
            ? "This is required."
            : "Invalid phone number."}
        </FormHelperText>
      )}
    </FormControl>
  );
}
FormPhoneField.propTypes = {
  fieldProps: PropTypes.shape({
    conditional: PropTypes.shape({
      when: PropTypes.string.isRequired,
      eq: PropTypes.string.isRequired,
      show: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    }),
    type: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    validate: PropTypes.shape({
      required: PropTypes.bool,
    }),
    defaultValue: PropTypes.string,
  }).isRequired,
  formProps: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool.isRequired,
};
export default FormPhoneField;
